"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submodelFieldFactory = void 0;
const errors_1 = require("../errors");
/**
 */
function submodelFieldFactory(options) {
    if (!options.name) {
        throw new errors_1.FieldError('Field must have a name.');
    }
    if (!options.model) {
        throw new errors_1.FieldError('Submodel field must have a model.');
    }
    if (!options.model.isSubmodel) {
        throw new errors_1.FieldError('Submodel must have isSubmodel = true');
    }
    function getDefault() {
        if (typeof options.defaultValue === 'function') {
            return (options.defaultValue());
        }
        if (options.defaultValue) {
            return options.defaultValue;
        }
        return undefined;
    }
    function validate(value) {
        var _a;
        // Explicitly check for `null` since `typeof null` is "object"
        if (typeof value !== 'object' || value === null || Array.isArray(value)) {
            throw new errors_1.ValidationError(`Field "${options.name}" must be a map`);
        }
        (_a = options.model) === null || _a === void 0 ? void 0 : _a.validate(value);
    }
    function fromDb(value) {
        if (value === undefined || value === null) {
            return undefined;
        }
        return options.model.fromDb('', value);
    }
    function toDb(value) {
        if (value === undefined) {
            return undefined;
        }
        return options.model.toDb(value);
    }
    function fromApi(value) {
        if (value === undefined || value === null) {
            return undefined;
        }
        return options.model.fromApi(value);
    }
    function toApi(value) {
        if (value === undefined) {
            return undefined;
        }
        return options.model.toApi(value);
    }
    return {
        name: options.name,
        isRequired: options.isRequired || false,
        getDefault,
        validate,
        fromDb,
        toDb,
        fromApi,
        toApi,
    };
}
exports.submodelFieldFactory = submodelFieldFactory;
//# sourceMappingURL=submodel.js.map